import { format } from 'date-fns';
import React, { useState, useEffect } from 'react';
import { DayPicker } from 'react-day-picker';
import nl from 'date-fns/locale/nl-BE';

import 'react-day-picker/dist/style.css';

import { useDispatch, useSelector } from 'react-redux';
import { setWeek } from '../redux/chooseWeekSlice';




const ChooseWeek = () => {
    const range = useSelector(state => state.chooseWeek.value);
    const dispatch = useDispatch();
    const [disabledDays, setDisabledDays ] = useState({})

    // useeffect that add the disabled days to the state, all dates before today are disabled
    useEffect(() => {
        let temp = []
        for (let i = 0; i < 365; i++) {
            let date = new Date()
            date.setDate(date.getDate() - (i + 1))
            temp.push(date)
        }
        setDisabledDays(temp)
    }, [])



    // turn the object with from and to into a date object with from and to
    const defaultSelected = {
        from: new Date(range.from),
        to: new Date(range.to)
    }

    const [dateRange, setDateRange] = useState(defaultSelected);

    const handleOnSelect = (e) => {
        if (e === undefined || e === null) {
            setDateRange({})
        }
        else if (e.from === undefined || e.from === null || e.to === undefined || e.to === null) {
            setDateRange(e)
        }
        else {
        const range = {
            from: e.from.getTime(),
            to: e.to.getTime()
        }
        dispatch(setWeek(range))
        setDateRange(e)
    }
    }

      let footer = <p>Kies de startdag</p>;
      if (range?.from) {
        if (!range.to) {
          footer = <p>{format(range.from, 'PPP')}</p>;
        } else if (range.to) {
          footer = (
            <p>
              <b>{format(range.from, 'dd-MM-yyyy')}</b> tot <b>{format(range.to, 'dd-MM-yyyy')}</b>
            </p>
          );
        }
      }

  return (
    <>
      <DayPicker
        locale={nl}
        mode="range"
        defaultMonth={dateRange.from}
        weekStartsOn={1}
        selected={dateRange}
        footer={footer}
        onSelect={handleOnSelect}
        modifiersStyles={{
          selected: { backgroundColor: '#1976d2' }
        }}
        disabled={disabledDays}
      />
    </>
  )
}

export default ChooseWeek